import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LicenseState } from '../reducers/license.reducer';
import { LICENSE_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<LicenseState>(LICENSE_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: LicenseState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: LicenseState) => state.loading);
export const selectSaving = createSelector(selectState, (state: LicenseState) => state.saving);
export const selectSaved = createSelector(selectState, (state: LicenseState) => state.saved);
export const selectError = createSelector(selectState, (state: LicenseState) => state.error);
export const selectLicense = createSelector(selectState, (state: LicenseState) => state.license);
